import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AdminTextInput from '../../../components/admin/admin-text-input';
import AdminError from '../../../components/admin/admin-error';
import Loader from '../../../components/Loader';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { defaultDealerUser } from './dealerItems';
import AdminPhone from '../../../components/admin/admin-phone';
import { submitDistrictSiteUserV2, editDistrictSiteUserV2 } from '../../../api/districtsiteuserapi';
import {
    getDistrictUserV2,
} from '../../../api/districtuserapi';
export function AddEditDealer() {
    const { districtId, dealerId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isEditDealer, setIsEditDealer] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [validation, setValidation] = useState({ schoolName: true, schoolNameError: '' });
    const [dealerUser, setDealerUser] = useState(defaultDealerUser);

    useEffect(() => {

        const loadDealerData = async () => {
            setIsEditDealer(false);
            setValidation({ schoolName: true, schoolNameError: '' });

            if (dealerId == null || dealerId == "") {
                setLoading(false);
                return;
            }

            try {
                const response = await getDistrictUserV2(districtId, dealerId);
                if (response.data.success) {
                    var result = response?.data?.data;
                    const dealerObj = {
                        siteUserId: result?.id,
                        role: 'Dealer',
                        fullName: result?.fullName,
                        email: result?.email,
                        phone: result?.phone,
                        pmFullName: result?.pmFullName,
                        pmContactEmail: result?.pmContactEmail,
                        pmContactPhone: result?.pmContactPhone,
                        salesFullName: result?.salesFullName,
                        salesContactEmail: result?.salesContactEmail,
                        salesContactPhone: result?.salesContactPhone,
                        companyName: result?.organization,
                        notify: result?.notify
                    };
                    setIsEditDealer(true);
                    setDealerUser(dealerObj);
                } else {
                    setErrorMessage(response.data.message || 'Failed to load dealer.');
                }
            } catch (error) {
                setIsEditDealer(false);
                console.error('Fetch error:', error);
                setErrorMessage('An unknown error occurred.');
            } finally {
                setLoading(false);
            }
        };

        loadDealerData();
    }, [districtId, dealerId]);



    const handleDealerSave = async () => {
        const isEmpty = (value) => !value || value.trim() === '';

        const validate = {
            siteUserId: true,
            fullName: !isEmpty(dealerUser.fullName),
            email: !isEmpty(dealerUser.email), 
            companyName: !isEmpty(dealerUser.companyName),
            password: true,
        };

        const isValid = Object.values(validate).every(Boolean);

        setValidation(prev => ({ ...prev, ...validate }));

        if (!isValid) return;

        const roleData = {
            DistrictId: districtId,
            SiteUserId: dealerUser.siteUserId,
            Role: "Dealer",
            Email: dealerUser.email,
            FullName: dealerUser.fullName,
            Phone: dealerUser.phone,
            PmFullName: dealerUser.pmFullName,
            PmContactEmail: dealerUser.pmContactEmail,
            PmContactPhone: dealerUser.pmContactPhone,
            SalesFullName: dealerUser.salesFullName,
            salesContactEmail: dealerUser.salesContactEmail,
            salesContactPhone: dealerUser.salesContactPhone,
            CompanyName: dealerUser.companyName,
            Password: dealerUser.password,
            Notify: dealerUser.notify,
        };

        try {
            dispatch(showLoading());
            const apiCall = isEditDealer ? editDistrictSiteUserV2 : submitDistrictSiteUserV2;
            const actionVerb = isEditDealer ? 'update' : 'add';

            const response = await apiCall(roleData);

            if (response.data.success) {
                navigate(`/admin/districts/edit/${districtId}/dealers`);
            } else {
                setErrorMessage(response.data.message || `Failed to ${actionVerb} dealer.`);
            }
        } catch (error) {
            console.error(`${isEditDealer ? 'Update' : 'Add'} error:`, error);
            setErrorMessage(`An unknown error occurred while trying to ${isEditDealer ? 'update' : 'add'} the dealer.`);
        } finally {
            setLoading(false);
            dispatch(hideLoading());
        }
    };


    const handleCancel = () => {
        navigate(`/admin/districts/edit/${districtId}/dealers`);
    };

    if (loading) return <Loader />;

    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link className="admin-top-bar-back" to={`/admin/districts/edit/${districtId}/dealers`}>
                        Back
                    </Link>
                </div>
            </div>

            <div className="admin-page-content">
                <h1 className="admin-page-heading">Add / Edit Dealer</h1>
                <AdminError message={errorMessage} onClose={() => setErrorMessage('')} />
                <div className="admin-section dealer-add-edit-section">
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="full-name"
                                label="First & Last Name"
                                placeholder=""
                                isRequired={true}
                                value={dealerUser.fullName ?? ''}
                                validated={validation.fullName}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, fullName: value });
                                    setValidation({ ...validation, fullName: value != '' });
                                }}
                                requiredText="First & Last Name is required"
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="email-address"
                                label="Email Address"
                                placeholder=""
                                isRequired={true}
                                value={dealerUser.email ?? ''}
                                validated={validation.email}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, email: value });
                                    setValidation({ ...validation, email: value != '' });
                                }}
                                requiredText="Email Address is required"
                            />
                        </div>
                    </div>

                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="company-name"
                                label="Supplier Organization"
                                placeholder=""
                                isRequired={true}
                                value={dealerUser.companyName ?? ''}
                                validated={validation.companyName}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, companyName: value });
                                    setValidation({ ...validation, companyName: value != '' });
                                }}
                                requiredText="Organization is required"
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="sales-full-name"
                                label="Sales First & Last Name"
                                value={dealerUser.salesFullName ?? ''}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, salesFullName: value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="sales-contact-email"
                                label="Sales Contact Email"
                                placeholder=""
                                value={dealerUser.salesContactEmail ?? ''}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, salesContactEmail: value });
                                }}
                            />
                        </div>
                    </div>

                    <div className="admin-modal-row">
                        <div className="admin-modal-cell pm-phone-cell">
                            <AdminPhone
                                id="sales-contact-phone"
                                label="Sales Contact Phone"
                                type="phone"
                                placeholder=""
                                value={dealerUser.salesContactPhone ?? ''}
                                loaded={true}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, salesContactPhone: value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="pm-full-name"
                                label="PM First & Last Name"
                                value={dealerUser.pmFullName ?? ''}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, pmFullName: value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="pm-contact-email"
                                label="PM Contact Email"
                                placeholder=""
                                value={dealerUser.pmContactEmail ?? ''}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, pmContactEmail: value });
                                }}
                            />
                        </div>
                    </div>

                    <div className="admin-modal-row">
                        <div className="admin-modal-cell pm-phone-cell">
                            <AdminPhone
                                id="pm-contact-phone"
                                label="PM Contact Phone"
                                type="phone"
                                placeholder=""
                                value={dealerUser.pmContactPhone ?? ''}
                                loaded={true}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, pmContactPhone: value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <AdminTextInput
                                id="password"
                                label="Password"
                                inputType="password"
                                placeholder="Leave blank to let user create their own password"
                                isRequired={false}
                                value={dealerUser.password ?? ''}
                                onChange={(value) => {
                                    setDealerUser({ ...dealerUser, password: value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell full">
                            <label className="admin-inline-label" htmlFor="notify">
                                <input
                                    id="notify"
                                    type="checkbox"
                                    checked={dealerUser.notify}
                                    onChange={() => setDealerUser({ ...dealerUser, notify: !dealerUser.notify })}

                                />
                                <span className="admin-inline-label-text">Notify when RFQ&apos;s are submitted to the district</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="admin-floating-button-wrap">
                    <button className="admin-floating-button" onClick={handleCancel}>
                        Cancel
                    </button>
                    <button className="admin-floating-button power" onClick={handleDealerSave}>
                        Save Changes
                    </button>
                </div>
            </div>

        </div>
    );
}
